import { Col, Form } from "antd";
import CustomDatePicker from "common/CustomDatePicker";
import moment from "moment";

const AbsenteeismInformedReasonFilterFields = () => {
  const today = moment();

  return (
    <>
      <Col span={4}>
        <Form.Item
          label="Start Date"
          name="start_date"
          initialValue={today}
          required
          rules={[
            {
              required: true,
              message: "Start Date is required",
            },
          ]}
        >
          <CustomDatePicker style={{ width: "100%" }} size="small" />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item
          label="End Date"
          name="end_date"
          initialValue={today}
          required
          rules={[
            {
              required: true,
              message: "End Date is required",
            },
          ]}
        >
          <CustomDatePicker style={{ width: "100%" }} size="small" />
        </Form.Item>
      </Col>
    </>
  );
};

export default AbsenteeismInformedReasonFilterFields;
